module.exports = __webpack_public_path__ + "static/media/startup-template-logo.9cd4b56a.webp";